// Generated by purs version 0.14.4
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var Key = function (x) {
    return x;
};
var Vault = function (x) {
    return x;
};
var unsafeToAny = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var unsafeFromAny = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var semigroupVault = {
    append: function (v) {
        return function (v1) {
            return Data_Map_Internal.union(Data_Ord.ordInt)(v)(v1);
        };
    }
};
var nextKey = Effect_Unsafe.unsafePerformEffect(Effect_Ref["new"](0));
var newKey = Data_Functor.map(Effect.functorEffect)(Key)(Effect_Ref.modify(function (v) {
    return v + 1 | 0;
})(nextKey));
var unsafeNewKey = function (dictEq) {
    return Effect_Unsafe.unsafePerformEffect(newKey);
};
var keyIndex = function (v) {
    return v;
};
var lookup = function (k) {
    return function (v) {
        return Data_Functor.map(Data_Maybe.functorMaybe)(unsafeFromAny(k))(Data_Map_Internal.lookup(Data_Ord.ordInt)(keyIndex(k))(v));
    };
};
var insert = function (k) {
    return function (v) {
        return function (v1) {
            return Vault(Data_Map_Internal.insert(Data_Ord.ordInt)(keyIndex(k))(unsafeToAny(k)(v))(v1));
        };
    };
};
var empty = Data_Map_Internal.empty;
var monoidVault = {
    mempty: empty,
    Semigroup0: function () {
        return semigroupVault;
    }
};
var singleton = function (k) {
    return function (v) {
        return insert(k)(v)(empty);
    };
};
export {
    newKey,
    unsafeNewKey,
    empty,
    insert,
    lookup,
    singleton,
    semigroupVault,
    monoidVault
};
//# sourceMappingURL=index.js.map
